import { render, staticRenderFns } from "./Group News.vue?vue&type=template&id=0ee4daca&scoped=true&"
import script from "./Group News.vue?vue&type=script&lang=js&"
export * from "./Group News.vue?vue&type=script&lang=js&"
import style0 from "./Group News.vue?vue&type=style&index=0&id=0ee4daca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee4daca",
  null
  
)

export default component.exports